export const subscriptionsKeys = {
    SUBSCRIPTIONS_DELETE: 'subscription/delete',
    SUBSCRIPTIONS_READ: 'subscription/read',

    SUBSCRIPTIONS_ENROLLMENT_CREATE: 'enrollment/create',
};